import classNames from "classnames"

import { ControlIntent } from "./ControlIntent"
import { ControlStateOptions } from "./ControlStateOptions"
import { determineControlBackgroundClass } from "./determineControlBackgroundClass"
import { determineControlBorderClass } from "./determineControlBorderClass"
import { determineControlCursorClass } from "./determineControlCursorClass"
import { determineControlOutlineClass } from "./determineControlOutlineClass"
import { determineControlPaddingClass } from "./determineControlPaddingClass"
import { determineControlTextClass } from "./determineControlTextClass"
import { determinePlaceholderTextClasses } from "./determinePlaceholderTextClasses"

/**
 *  Determine CSS classes for the control box based on the passed state options.
 *  The classes will describe the background, border, and padding of the box.
 *  In some cases, additional properties, like drop-shadow or so, might be added.
 */
export function determineControlBoxClass(state: ControlStateOptions, intent: ControlIntent = "editable") {
  return classNames(
    { "opacity-40": state.disabled },
    determineControlCursorClass(state, intent),
    determineControlTextClass(state),
    determineControlOutlineClass(state),
    determinePlaceholderTextClasses(state),
    determineControlPaddingClass(state),
    determineControlBackgroundClass(state),
    determineControlBorderClass(state)
  )
}
